import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import ContactCard from './ContactCard';

const HelpApplicationCards = ({ list, open, handleOpenCheckin }) => {
  return (
    <>
      <Grid container direction="row">
        {list &&
          list.map((r) => {
            return (
              <Grid item xs={12} sm={6} md={4} key={r.id}>
                <ContactCard app={r} open={open} handleOpenCheckin={handleOpenCheckin} />
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};

HelpApplicationCards.propTypes = {
  list: PropTypes.array.isRequired,
  handleOpenCheckin: PropTypes.func.isRequired,
};

export default HelpApplicationCards;
